import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

function ScorePopup({ points, visible, streakBonus = false, streak = 0 }) {
  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          key={points + '-' + Date.now()}
          initial={{ opacity: 1, y: 0, scale: 0.6, rotate: -20 }}
          animate={{ opacity: 0, y: -120, scale: 1.5, rotate: 0 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 1.2, ease: [0.16, 1, 0.3, 1] }}
          style={{
            position: 'fixed',
            top: '35%',
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: 9999,
            pointerEvents: 'none',
            textAlign: 'center',
          }}
        >
          {/* Points */}
          <motion.div
            initial={{ scale: 0.5 }}
            animate={{ scale: 1 }}
            transition={{ type: 'spring', stiffness: 300, damping: 20 }}
            style={{
              fontFamily: "'Rajdhani', sans-serif",
              fontWeight: 900,
              fontSize: streakBonus ? '3.5rem' : '2.8rem',
              lineHeight: 1,
              color: streakBonus ? '#FFB81C' : '#22c55e',
              textShadow: streakBonus
                ? '0 0 40px rgba(255,184,28,1), 0 0 80px rgba(255,184,28,0.6), 0 0 120px rgba(255,184,28,0.3)'
                : '0 0 30px rgba(34,197,94,1), 0 0 60px rgba(34,197,94,0.6), 0 0 90px rgba(34,197,94,0.3)',
              whiteSpace: 'nowrap',
              letterSpacing: '0.05em',
            }}
          >
            +{points}
          </motion.div>

          {/* Bonus streak */}
          {streakBonus && streak > 1 && (
            <motion.div
              initial={{ opacity: 0, scale: 0, y: -10 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              transition={{ delay: 0.1, type: 'spring', stiffness: 200, damping: 20 }}
              style={{
                fontFamily: "'Rajdhani', sans-serif",
                fontWeight: 800,
                fontSize: '1.1rem',
                color: '#FFB81C',
                letterSpacing: '0.12em',
                marginTop: 8,
                textShadow: '0 0 20px rgba(255,184,28,0.8), 0 0 40px rgba(255,184,28,0.4)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 6,
              }}
            >
              <motion.span
                animate={{ rotate: [0, -10, 10, -10, 0] }}
                transition={{ duration: 1.2, repeat: Infinity, repeatDelay: 0.5 }}
              >
                🔥
              </motion.span>
              SÉRIE x{streak}
              <motion.span
                animate={{ rotate: [0, 10, -10, 10, 0] }}
                transition={{ duration: 1.2, repeat: Infinity, repeatDelay: 0.5 }}
              >
                🔥
              </motion.span>
            </motion.div>
          )}
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default ScorePopup;
